import React from 'react';
import Loadable from 'react-loadable';

import FirstLoader from '../FirstLoader/FirstLoader';

const LoadablePaymentMethodsWizard = Loadable({
  loader: () => import(/* webpackChunkName: "PaymentMethods" */ './PaymentMethodsWizard'),
  modules: ['./PaymentMethods'],
  loading: () => <FirstLoader />
});

export default LoadablePaymentMethodsWizard;
